export const DEVICE_STATUS_STALE_TIME = 2 * 60 * 1000;
export const DEFAULT_DEVICE_STATUS_REFRESH_INTERVAL = 30 * 1000;
export const DEVICE_STATUS_PROJECTION_REFRESH_INTERVAL = 30 * 1000;
// Filter changes apply after this pause, so ticking a few values in a row
// fires one report request, not one per click.
export const FILTER_APPLY_DEBOUNCE_MS = 500;

export const deviceStatusFreshness = Object.freeze({
  staleTime: DEVICE_STATUS_STALE_TIME,
  refetchOnWindowFocus: false,
});

// The reports are minutes-long computations, so a failed one must not be
// retried: the global 3-retry policy would keep a backend connection busy long
// after the user moved on. Previous data stays on screen while the next range
// loads instead of blanking to a spinner.
export const reportQueryFreshness = refreshIntervalMs => ({
  staleTime: refreshIntervalMs ?? DEVICE_STATUS_STALE_TIME,
  refetchInterval: refreshIntervalMs ?? false,
  refetchIntervalInBackground: false,
  refetchOnWindowFocus: refreshIntervalMs != null,
  retry: false,
  placeholderData: previous => previous,
});
